import React, { useContext } from 'react';
import './latestDesigns.css'
import Item from '../items/item'
import { Link } from 'react-router-dom';
import { ShopContext } from '../../context/shopContext';



const LatestDesigns = ()=>{

    const {newProducts} = useContext(ShopContext)



    return (
            <div className='latest-designs'>
                <div className='titles'>
                    <div>
                        <h2>Latest Designs</h2>
                        <p>The latest and greatest in bastard design.</p>
                    </div>
                    <div className='shop-all-button'>
                        <Link to='/all'><p>Shop all</p></Link>
                    </div>
    
    
                </div>
    
    
                <div className="latest-designs-item">
                    {newProducts.map((item, i) => {
                        return <Item key={i} id={item.id} name={item.name} image={item.image} price={item.price} occasion={item.occasion} />
                    })}
                </div>
            </div>
        
    )
}

export default LatestDesigns
